import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '../hooks/useAnalytics';
import { useCookieConsent } from '../contexts/CookieConsentContext';

/**
 * Analytics Provider component that handles:
 * - Automatic page view tracking on route changes
 * - GDPR consent enforcement
 * - Analytics initialization and cleanup
 */
const AnalyticsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const { trackPageView, analyticsEnabled, getAnalyticsStatus } = useAnalytics();
  const { consent } = useCookieConsent();

  // Track page views on route changes
  useEffect(() => {
    if (analyticsEnabled) {
      // Get page title from document or generate from path
      const pageTitle = document.title || 'VST Shop';
      const pagePath = location.pathname + location.search;
      
      // Track the page view
      trackPageView(pagePath, pageTitle);
    }
  }, [location, analyticsEnabled, trackPageView]);



  return <>{children}</>;
};

export default AnalyticsProvider;